export class Modelo3D {

    Id: string;
    Nombre: string;
    Descripcion: string;
    FechaAlta: Date;
    NombreFichero: string;
	FechaActualizacionFichero: Date;

	IdExt_ios: string;
	IdExt_android: string;
	UrlExt_ios: string;
	UrlExt_android: string;

    GeocalibracionActiva: boolean;
    Metros_Aparicion: number;
    Orientacion: number;
    Latitud_topLeft: number;
    Longitud_topLeft: number;
    Latitud_topRight: number;
    Longitud_topRight: number;
    Latitud_bottomRight: number;
    Longitud_bottomRight: number;
    Latitud_bottomLeft: number;
    Longitud_bottomLeft: number;
    width: number;
	height: number;

	// visible: boolean;

	ENTIDAD: any;

    constructor() {

		this.Nombre = '';
		this.Descripcion = '';
		this.FechaAlta = new Date();
		this.NombreFichero = '';
		this.GeocalibracionActiva = false;
		this.Metros_Aparicion = 0;

		this.Orientacion = 0;
        this.Latitud_topLeft = 0;
        this.Longitud_topLeft = 0;
        this.Latitud_topRight = 0;
        this.Longitud_topRight = 0;
        this.Latitud_bottomRight = 0;
        this.Longitud_bottomRight = 0;
        this.Latitud_bottomLeft = 0;
        this.Longitud_bottomLeft = 0;
        this.width = 0;
		this.height = 0;

		this.FechaActualizacionFichero = new Date();

		this.IdExt_ios = '';
		this.IdExt_android = '';
		this.UrlExt_ios = '';
		this.UrlExt_android = '';

		// this.visible = false;

    }

    fromENTIDAD(ENTIDAD: any): Modelo3D{

		if (ENTIDAD) {
			this.ENTIDAD = ENTIDAD;

			this.Id = this.ENTIDAD.Id;
			this.Nombre = this.ENTIDAD.Nombre;
			this.Descripcion = this.ENTIDAD.Descripcion ? this.ENTIDAD.Descripcion : '' ;
			this.FechaAlta = this.ENTIDAD.FechaAlta;

			this.NombreFichero = this.ENTIDAD.NombreFichero;
			this.FechaActualizacionFichero = this.ENTIDAD.FechaActualizacionFichero;

			this.IdExt_ios = this.ENTIDAD.IdExt_ios;
			this.IdExt_android = this.ENTIDAD.IdExt_android;
			this.UrlExt_ios = this.ENTIDAD.UrlExt_ios;
			this.UrlExt_android = this.ENTIDAD.UrlExt_android;

			this.GeocalibracionActiva = this.ENTIDAD.GeocalibracionActiva;
			this.Metros_Aparicion = this.ENTIDAD.Metros_Aparicion;
			this.Orientacion = this.ENTIDAD.Orientacion;
			this.Latitud_topLeft = this.ENTIDAD.Latitud_topLeft;
			this.Longitud_topLeft =  this.ENTIDAD.Longitud_topLeft;
			this.Latitud_topRight =  this.ENTIDAD.Latitud_topRight;
			this.Longitud_topRight =  this.ENTIDAD.Longitud_topRight;
			this.Latitud_bottomRight = this.ENTIDAD.Latitud_bottomRight;
			this.Longitud_bottomRight = this.ENTIDAD.Longitud_bottomRight;
			this.Latitud_bottomLeft = this.ENTIDAD.Latitud_bottomLeft;
			this.Longitud_bottomLeft = this.ENTIDAD.Longitud_bottomLeft;
			this.width = this.ENTIDAD.width;
			this.height = this.ENTIDAD.height;
		}


		return this;
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Modelo3D.ts